import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({ dispatch }, payload) => {
    return serves.folharevento.cadastra(payload).then(res => {
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}
export const ActionCadastro1210 = ({ dispatch }, payload) => {
    return serves.folharevento.cadastra1210(payload).then(res => {
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}
export const ActionLista = ({ dispatch }, payload) => {
    return serves.folharevento.lista(payload).then(res => {
        dispatch('ActionSetLista', res)
    }).catch(err => {
        dispatch('ActionSetLista', err)
    })
}
export const ActionPesquisa = ({ dispatch }, payload) => {
    return serves.folharevento.lista(payload).then(res => {
        dispatch('ActionSetBoletins', res)
    }).catch(err => {
        dispatch('ActionSetBoletins', res)
    })
}
export const ActionInss = ({ dispatch }, payload) => {
    return serves.folharevento.inss(payload).then(res => {
        dispatch('ActionSetInss', res)
    }).catch(err => {
        dispatch('ActionSetInss', res)
    })
}
export const ActionDeletar = ({ dispatch }, payload) => {
    return serves.folharevento.delete(payload).then(res => {
       
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}
export const ActionEditar = ({ dispatch }, payload) => {
    return serves.folharevento.editar(payload).then(res => {
        dispatch('ActionSetEditar', res)
    }).catch(err => {
        dispatch('ActionSetEditar', err)
    })
}
export const ActionUpdate = ({ dispatch }, payload) => {
    return serves.folharevento.update(payload).then(res => {
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}
export const ActionEventoUpdate = ({ dispatch }, payload) => {
    if (payload.evento === '1200') {
        return serves.folharevento.update1200(payload).then(res => {
            dispatch('ActionSetMsg', res)
        }).catch(err => {
            dispatch('ActionSetMsg', err)
        })
    } else {
        return serves.folharevento.update1210(payload).then(res => {
            dispatch('ActionSetMsg', res)
        }).catch(err => {
            dispatch('ActionSetMsg', err)
        })
    }
}
export const ActionEventoDeletar = ({ dispatch }, payload) => {
    if (payload.evento === '1200') {
        return serves.folharevento.delete1200(payload).then(res => {
            dispatch('ActionSetMsg', res)
        }).catch(err => {
            dispatch('ActionSetMsg', err)
        })
    } else {
        return serves.folharevento.delete1210(payload).then(res => {
            dispatch('ActionSetMsg', res)
        }).catch(err => {
            dispatch('ActionSetMsg', err)
        })
    }
}
export const ActionEventoDeleta = ({ dispatch }, payload) => {
    return serves.folharevento.delete1200(payload).then(res => {
        dispatch('ActionSetMsg', res)
    }).catch(err => {
        dispatch('ActionSetMsg', err)
    })
}
export const ActionSetLista = ({ commit }, payload) => {
    commit(types.SET_LISTA, payload)
}
export const ActionSetMsg = ({ commit }, payload) => {
    commit(types.SET_MSG, payload)
}
export const ActionSetEditar = ({ commit }, payload) => {
    commit(types.SET_EDITAR, payload)
}
export const ActionSetBoletins = ({ commit }, payload) => {
    commit(types.SET_BOLETINS, payload)
}
export const ActionSetInss = ({ commit }, payload) => {
    commit(types.SET_INSS, payload)
}
